const experienceData = [
  {
    role: "Working Student - Diagnostic Imaging Digital and Automation Platforms",
    company: "Siemens Healthineers",
    location: "Erlangen, Germany", // TODO: confirm
    start: "2026-02",
    end: "present",
    description: [
      "Building data pipelines for analysis and preparation feeding ML model development",
      "Supporting ML models for business insight generation and VR simulations",
    ],
    logo: process.env.PUBLIC_URL + "/logos/siemens-healthineers.png"
  },
  {
    role: "Quantitative Developer Intern",
    company: "Citibank",
    location: "Budapest, Hungary", // TODO: confirm
    start: "2024-06",
    end: "2025-03",
    description: [
      "Rebuilt monitoring and testing frameworks to optimize system capacity and performance across asset classes",
      "Developed full-stack solutions using Python, React, Node.js, and MongoDB within Agile teams",
    ],
    logo: process.env.PUBLIC_URL + "/assets/logo1.png"
  },
  {
    role: "Python and Java(OOP) Instructor",
    company: "ELTE Faculty of Informatics",
    location: "Budapest, Hungary",
    start: "2025-02",
    end: "2025-06",
    description: [
      "Taught core programming and OOP concepts to undergraduates using Python and Java",
      "Designed lab exercises, quizzes, and projects emphasizing real-world problem-solving and modular design",
      "Conducted consultations and evaluations for 100+ students to reinforce learning outcomes",
    ],
    logo: process.env.PUBLIC_URL + "/logos/ELTE_logo.png"
  },
  {
    role: "Technical Lead",
    company: "Google Developers Group, on Campus ELTE",
    location: "Budapest, Hungary",
    start: "2024-10",
    end: "2025-06",
    description: [
      "Led design of technical content and coding challenges for workshops and hackathons at ELTE",
      "Collaborated with mentors to deliver industry-aligned, up-to-date learning experiences",
    ],
    logo: process.env.PUBLIC_URL + "/logos/GDG_logo.webp"
  }
];

export default experienceData;
